// Rush Studio — Automations (continuous localization rule builder)
// Implements the design shipped from Claude Design (Automations.html).
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../../slices/authSlice';
import '../../DashboardHome/automations.css';
import '../../DashboardHome/settings.css';

// ============================================================
// Icons
// ============================================================
const AUI = {
    pr: (<svg viewBox="0 0 16 16" width="16" height="16" fill="none"><circle cx="4" cy="4" r="2" stroke="currentColor" strokeWidth="1.5"/><circle cx="4" cy="12" r="2" stroke="currentColor" strokeWidth="1.5"/><circle cx="12" cy="12" r="2" stroke="currentColor" strokeWidth="1.5"/><path d="M4 6v4M12 10V8a2 2 0 00-2-2H7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>),
    file: (<svg viewBox="0 0 16 16" width="16" height="16" fill="none"><path d="M4 2.5h5l3 3v8H4z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><path d="M9 2.5V6h3" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></svg>),
    flag: (<svg viewBox="0 0 16 16" width="16" height="16" fill="none"><path d="M4 14V3M4 3h7l-1.3 2.2L11 8H4" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round"/></svg>),
    clock: (<svg viewBox="0 0 16 16" width="16" height="16" fill="none"><circle cx="8" cy="8" r="5.5" stroke="currentColor" strokeWidth="1.5"/><path d="M8 5v3l2 1.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>),
    check: (<svg viewBox="0 0 16 16" width="16" height="16" fill="none"><circle cx="8" cy="8" r="5.5" stroke="currentColor" strokeWidth="1.5"/><path d="M5.5 8l1.8 1.8L10.5 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>),
    comment: (<svg viewBox="0 0 16 16" width="16" height="16" fill="none"><path d="M2.5 8a5 5 0 015-5h1a5 5 0 015 5v3a1 1 0 01-1 1H8L5 14v-2H3.5a1 1 0 01-1-1V8z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></svg>),
    ai: (<svg viewBox="0 0 16 16" width="16" height="16" fill="none"><path d="M8 2l1.4 3.1L12.5 6 9.4 7.4 8 10.5 6.6 7.4 3.5 6l3.1-.9L8 2z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round"/></svg>),
    person: (<svg viewBox="0 0 16 16" width="16" height="16" fill="none"><circle cx="8" cy="6" r="2.6" stroke="currentColor" strokeWidth="1.5"/><path d="M3 13c.8-2.4 2.6-3.6 5-3.6s4.2 1.2 5 3.6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>),
    bell: (<svg viewBox="0 0 16 16" width="16" height="16" fill="none"><path d="M4 11V7.5a4 4 0 018 0V11l1 1.5H3L4 11z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><path d="M6.5 13.5a1.5 1.5 0 003 0" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>),
    export: (<svg viewBox="0 0 16 16" width="16" height="16" fill="none"><path d="M8 10V3m0 0L5 6m3-3l3 3M3 12.5h10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>),
    glossary: (<svg viewBox="0 0 16 16" width="16" height="16" fill="none"><path d="M3 3h7l3 3v7H3z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><path d="M5 7h6M5 9.5h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>),
    status: (<svg viewBox="0 0 16 16" width="16" height="16" fill="none"><rect x="2.5" y="4" width="11" height="8" rx="1.5" stroke="currentColor" strokeWidth="1.5"/><path d="M6 8h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>),
    arrow: (<svg viewBox="0 0 16 12" width="16" height="12" fill="none"><path d="M2 6h11M10 2.5L13.5 6 10 9.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>),
    plus: (<svg viewBox="0 0 14 14" width="13" height="13" fill="none"><path d="M7 2v10M2 7h10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>),
    x: (<svg viewBox="0 0 14 14" width="12" height="12" fill="none"><path d="M3.5 3.5l7 7M10.5 3.5l-7 7" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/></svg>),
    more: (<svg viewBox="0 0 14 14" width="14" height="14" fill="none"><circle cx="3" cy="7" r="1" fill="currentColor"/><circle cx="7" cy="7" r="1" fill="currentColor"/><circle cx="11" cy="7" r="1" fill="currentColor"/></svg>),
    bolt: (<svg viewBox="0 0 16 16" width="16" height="16" fill="none"><path d="M9 2L3 9h4l-1 5 6-7H8l1-5z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></svg>),
    chev: (<svg viewBox="0 0 16 16" width="14" height="14" fill="none"><path d="M4 6l4 4 4-4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/></svg>),
    warn: (<svg viewBox="0 0 16 16" width="15" height="15" fill="none"><path d="M8 2.2l6 10.6H2L8 2.2z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><path d="M8 6.5v3M8 11.3v.01" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>),
    copy: (<svg viewBox="0 0 16 16" width="14" height="14" fill="none"><rect x="5.5" y="5.5" width="8" height="8" rx="1.5" stroke="currentColor" strokeWidth="1.4"/><path d="M3 10.5A1.5 1.5 0 012.5 9.4V3.5A1.5 1.5 0 014 2h5.4A1.5 1.5 0 0110.5 3" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/></svg>),
    pencil: (<svg viewBox="0 0 16 16" width="14" height="14" fill="none"><path d="M11 2.5l2.5 2.5M3 13l1-3 7-7 2.5 2.5-7 7-3 1z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round"/></svg>),
    trash: (<svg viewBox="0 0 16 16" width="14" height="14" fill="none"><path d="M3 4.5h10M6.5 4V2.8h3V4M4.5 4.5l.5 8.5h6l.5-8.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/></svg>),
    history: (<svg viewBox="0 0 16 16" width="14" height="14" fill="none"><path d="M2.6 8a5.4 5.4 0 102-4.2M2.5 3v2.6h2.6" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/><path d="M8 5.3V8l2 1.4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/></svg>),
    rerun: (<svg viewBox="0 0 16 16" width="13" height="13" fill="none"><path d="M13 8a5 5 0 11-1.5-3.6M13 2.5v2.6h-2.6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>),
    figma: (<svg viewBox="0 0 16 16" width="16" height="16" fill="none"><rect x="6" y="2.2" width="4" height="3.8" rx="1.9" stroke="currentColor" strokeWidth="1.3"/><rect x="6" y="6" width="4" height="3.8" rx="1.9" stroke="currentColor" strokeWidth="1.3"/><rect x="2.2" y="2.2" width="3.8" height="3.8" rx="1.9" stroke="currentColor" strokeWidth="1.3"/><rect x="2.2" y="6" width="3.8" height="3.8" rx="1.9" stroke="currentColor" strokeWidth="1.3"/><rect x="2.2" y="9.9" width="3.8" height="3.9" rx="1.95" stroke="currentColor" strokeWidth="1.3"/></svg>),
    move: (<svg viewBox="0 0 16 16" width="16" height="16" fill="none"><path d="M2 4.5A1.5 1.5 0 013.5 3H6l1.2 1.4H12.5A1.5 1.5 0 0114 5.9v5.6A1.5 1.5 0 0112.5 13h-9A1.5 1.5 0 012 11.5v-7z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round"/><path d="M6.5 8.7h4M9 7l1.8 1.7L9 10.4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/></svg>),
    share: (<svg viewBox="0 0 16 16" width="16" height="16" fill="none"><circle cx="4" cy="8" r="1.9" stroke="currentColor" strokeWidth="1.4"/><circle cx="11.5" cy="4" r="1.9" stroke="currentColor" strokeWidth="1.4"/><circle cx="11.5" cy="12" r="1.9" stroke="currentColor" strokeWidth="1.4"/><path d="M5.7 7.1l4.1-2.2M5.7 8.9l4.1 2.2" stroke="currentColor" strokeWidth="1.4"/></svg>),
    push: (<svg viewBox="0 0 16 16" width="16" height="16" fill="none"><path d="M8 13V5m0 0L5 8m3-3l3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><path d="M5 3h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>),
    label: (<svg viewBox="0 0 16 16" width="16" height="16" fill="none"><path d="M2.5 6.5l4-4H13V9l-6.5 4.5L2.5 9.5v-3z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round"/><circle cx="9.5" cy="5.5" r="1" fill="currentColor"/></svg>),
    message: (<svg viewBox="0 0 16 16" width="16" height="16" fill="none"><path d="M2.5 4.5A1.5 1.5 0 014 3h8a1.5 1.5 0 011.5 1.5v5A1.5 1.5 0 0112 11H6l-3 2.2V11H4a1.5 1.5 0 01-1.5-1.5v-5z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round"/></svg>),
    reaction: (<svg viewBox="0 0 16 16" width="16" height="16" fill="none"><circle cx="8" cy="8" r="5.5" stroke="currentColor" strokeWidth="1.4"/><path d="M6 7v.01M10 7v.01M5.8 9.7c.5.8 1.3 1.3 2.2 1.3s1.7-.5 2.2-1.3" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/></svg>),
};

// ============================================================
// Catalogues
// ============================================================
// Connector state is read from /api/integrations (with safe defaults for the
// integrations the platform supports out of the box).
const DEFAULT_CONNECTED = { gdrive: true, dropbox: true, onedrive: true, slack: true, figma: true, github: false };
const CONNECTOR_META = { github: 'GitHub', gdrive: 'Google Drive', dropbox: 'Dropbox', onedrive: 'OneDrive', slack: 'Slack', figma: 'Figma' };
const SOURCE_CONNECTOR = { 'Google Drive': 'gdrive', Dropbox: 'dropbox', OneDrive: 'onedrive', Figma: 'figma', GitHub: 'github' };
const STORAGE_SRCS = ['Google Drive', 'Dropbox', 'OneDrive'];
const REPOS = ['acme/strings', 'acme/website', 'acme/mobile'];

// Each trigger declares `conds` — the condition fields that make sense for
// it. The IF picker filters its options to that set so we never offer
// "TM match below" for a Slack message or "Folder" for a deadline. Triggers
// without `conds` get the broad project-level set so they're still usable.
const TRIGGERS = {
    // Cloud storage
    file_added: { label: 'File added or changed', icon: AUI.file, storage: true, srcLabel: 'Source', srcs: STORAGE_SRCS, conds: ['filetype', 'folder', 'language', 'wordcount', 'project'] },
    file_moved: { label: 'File moved into folder', icon: AUI.move, storage: true, srcLabel: 'Source', srcs: STORAGE_SRCS, conds: ['filetype', 'folder', 'project'] },
    file_shared: { label: 'Shared with the team', icon: AUI.share, storage: true, srcLabel: 'Source', srcs: STORAGE_SRCS, conds: ['filetype', 'folder', 'project'] },
    // Figma
    figma_changed: { label: 'Frame or component changed', icon: AUI.figma, needs: 'figma', conds: ['project', 'language'] },
    figma_page: { label: 'New page added', icon: AUI.figma, needs: 'figma', conds: ['project'] },
    figma_ready: { label: 'Marked “Ready for translation”', icon: AUI.flag, needs: 'figma', conds: ['project', 'language', 'urgency'] },
    // Slack
    slack_message: { label: 'Message posted', icon: AUI.message, needs: 'slack', srcLabel: 'Channel', srcs: ['#localization', '#general', '#eng'], conds: ['project'] },
    slack_mention: { label: '@mention of the team', icon: AUI.comment, needs: 'slack', conds: ['project'] },
    slack_reaction: { label: 'Reaction added 🌍', icon: AUI.reaction, needs: 'slack', conds: ['project', 'language'] },
    // GitHub
    pr: { label: 'Pull request opened', icon: AUI.pr, needs: 'github', srcLabel: 'Repository', srcs: REPOS, conds: ['filetype', 'language', 'project'] },
    push: { label: 'Push to branch', icon: AUI.push, needs: 'github', srcLabel: 'Repository', srcs: REPOS, conds: ['filetype', 'language', 'project'] },
    issue_label: { label: 'Issue labeled', icon: AUI.label, needs: 'github', srcLabel: 'Label', srcs: ['l10n', 'translate', 'i18n'], conds: ['project', 'language'] },

    // Translation workflow — per-segment / per-file events that drive day-to-day routing
    segment_translated: { label: 'Segment translated', icon: AUI.ai, conds: ['language', 'source_lang', 'project', 'assignee', 'has_glossary', 'wordcount'] },
    approved: { label: 'Segment approved', icon: AUI.check, conds: ['language', 'project', 'assignee', 'workflow', 'has_glossary', 'wordcount'] },
    review_rejected: { label: 'Segment rejected in review', icon: AUI.warn, conds: ['language', 'project', 'assignee', 'workflow'] },
    comment_added: { label: 'Comment or @mention on a segment', icon: AUI.comment, conds: ['language', 'project', 'assignee'] },
    status_changed: { label: 'Workflow status changed', icon: AUI.status, srcLabel: 'New status', srcs: ['In translation', 'In review', 'Approved', 'Done'], conds: ['language', 'project', 'assignee'] },
    assignee_changed: { label: 'Linguist assigned or changed', icon: AUI.person, conds: ['language', 'project', 'assignee'] },
    batch_submitted: { label: 'Translator submits for review', icon: AUI.push, conds: ['language', 'project', 'assignee', 'wordcount'] },

    // Project lifecycle
    project_created: { label: 'Project created', icon: AUI.bolt, conds: ['language', 'source_lang', 'client', 'urgency', 'project', 'wordcount'] },
    project_assigned: { label: 'Project assigned to you or your team', icon: AUI.person, conds: ['language', 'client', 'urgency', 'project'] },
    language_added: { label: 'Target language added to project', icon: AUI.flag, conds: ['language', 'project', 'client'] },
    deadline: { label: 'Deadline approaching', icon: AUI.flag, srcLabel: 'Lead time', srcs: ['1 hour', '24 hours', '3 days', '1 week'], conds: ['language', 'project', 'client', 'urgency', 'workflow'] },
    overdue: { label: 'Project past deadline', icon: AUI.warn, conds: ['language', 'project', 'client', 'urgency'] },
    done: { label: 'Project reaches 100%', icon: AUI.check, conds: ['language', 'project', 'client'] },

    // Quality & memory
    tm_low_match: { label: 'TM match drops below threshold', icon: AUI.history, srcLabel: 'Threshold', srcs: ['75%', '85%', '95%', '100%'], conds: ['language', 'project', 'match'] },
    glossary_violation: { label: 'Glossary term violated', icon: AUI.glossary, conds: ['language', 'project', 'assignee'] },
    quality_low: { label: 'AI quality score below threshold', icon: AUI.warn, srcLabel: 'Below', srcs: ['70', '80', '90'], conds: ['language', 'project', 'quality', 'assignee'] },
    source_changed: { label: 'Source text changed after translation', icon: AUI.pencil, conds: ['language', 'project', 'filetype'] },
    inconsistency_found: { label: 'Same source translated inconsistently', icon: AUI.warn, conds: ['language', 'project', 'assignee'] },

    // Schedule
    schedule: { label: 'On a schedule', icon: AUI.clock, srcLabel: 'Frequency', srcs: ['Every hour', 'Daily · 09:00', 'Weekly · Monday'], conds: ['language', 'project', 'client', 'workflow'] },
};
const TRIGGER_GROUPS = [
    { id: 'workflow', label: 'Translation workflow', connectors: [], items: ['segment_translated', 'approved', 'review_rejected', 'comment_added', 'status_changed', 'assignee_changed', 'batch_submitted'] },
    { id: 'project', label: 'Project lifecycle', connectors: [], items: ['project_created', 'project_assigned', 'language_added', 'deadline', 'overdue', 'done'] },
    { id: 'quality', label: 'Quality & memory', connectors: [], items: ['tm_low_match', 'glossary_violation', 'quality_low', 'source_changed', 'inconsistency_found'] },
    { id: 'schedule', label: 'Schedule', connectors: [], items: ['schedule'] },
    { id: 'storage', label: 'Cloud storage', connectors: ['gdrive', 'dropbox', 'onedrive'], items: ['file_added', 'file_moved', 'file_shared'] },
    { id: 'figma', label: 'Figma', connectors: ['figma'], items: ['figma_changed', 'figma_page', 'figma_ready'] },
    { id: 'slack', label: 'Slack', connectors: ['slack'], items: ['slack_message', 'slack_mention', 'slack_reaction'] },
    { id: 'github', label: 'GitHub', connectors: ['github'], items: ['pr', 'push', 'issue_label'] },
];

const TARGET_LANGS = [
    { code: 'DE', name: 'German' }, { code: 'FR', name: 'French' }, { code: 'JA', name: 'Japanese' },
    { code: 'ES', name: 'Spanish' }, { code: 'IT', name: 'Italian' }, { code: 'PT', name: 'Portuguese' },
    { code: 'ZH', name: 'Chinese' }, { code: 'KO', name: 'Korean' }, { code: 'NL', name: 'Dutch' },
];
const langName = (code) => (TARGET_LANGS.find((l) => l.code === code) || { name: code }).name;

const pick = (opts, v) => (opts.find((o) => o.value === v) || { label: v }).label;
const ACTIONS = {
    translate: {
        label: 'Translate', icon: AUI.ai, needs: null,
        def: { langs: ['DE', 'FR', 'JA'], engine: 'auto', pretranslate: true },
        fields: [
            { key: 'langs', type: 'langs', label: 'Target languages' },
            { key: 'engine', type: 'select', label: 'Engine', options: [
                { value: 'auto', label: 'Auto · best per language' }, { value: 'deepl', label: 'DeepL' },
                { value: 'google', label: 'Google' }, { value: 'openai', label: 'GPT-4o' }] },
            { key: 'pretranslate', type: 'toggle', label: 'Fill from TM first', desc: 'Apply 100% memory matches before machine translation.' },
        ],
        summary: (c) => `into ${c.langs && c.langs.length ? c.langs.join(', ') : 'no languages'}`,
    },
    route: {
        label: 'Auto-assign', icon: AUI.person, needs: null,
        def: { by: 'language', to: 'default' },
        fields: [
            { key: 'by', type: 'select', label: 'Assign by', options: [
                { value: 'language', label: 'Language pair' }, { value: 'folder', label: 'Folder' }, { value: 'workload', label: 'Lowest workload' }] },
            { key: 'to', type: 'select', label: 'Assign to', options: [
                { value: 'default', label: 'Default linguist for the pair' }, { value: 'roundrobin', label: 'Round-robin in team' },
                { value: 'anja', label: 'Anja Müller' }, { value: 'luis', label: 'Luís Ferreira' }] },
        ],
        summary: (c) => `by ${c.by === 'language' ? 'language' : c.by === 'folder' ? 'folder' : 'workload'} to ${pick(ACTIONS.route.fields[1].options, c.to).replace(' for the pair', '')}`,
    },
    notify: {
        label: 'Send notification', icon: AUI.bell, needs: 'slack',
        def: { channel: '#localization', event: 'complete' },
        fields: [
            { key: 'channel', type: 'select', label: 'Channel', options: [
                { value: '#localization', label: '#localization' }, { value: '#general', label: '#general' },
                { value: '#eng', label: '#eng' }, { value: 'email', label: 'Email the owner' }] },
            { key: 'event', type: 'select', label: 'Notify', options: [
                { value: 'complete', label: 'When the run completes' }, { value: 'start', label: 'When the run starts' }, { value: 'fail', label: 'Only if it fails' }] },
        ],
        summary: (c) => (c.channel === 'email' ? 'the owner by email' : `${c.channel} on Slack`),
    },
    export: {
        label: 'Export & deliver', icon: AUI.export, needs: null,
        def: { format: 'xliff-docx', dest: 'source' },
        fields: [
            { key: 'format', type: 'select', label: 'Format', options: [
                { value: 'xliff-docx', label: 'XLIFF + DOCX' }, { value: 'xliff', label: 'XLIFF only' },
                { value: 'json', label: 'JSON (i18n)' }, { value: 'csv', label: 'CSV' }] },
            { key: 'dest', type: 'select', label: 'Deliver', options: [
                { value: 'source', label: 'Back to the source' }, { value: 'download', label: 'As a download bundle' }, { value: 'email', label: 'Email a link' }] },
        ],
        summary: (c) => `${pick(ACTIONS.export.fields[0].options, c.format)} ${c.dest === 'source' ? 'back to source' : c.dest === 'download' ? 'as a bundle' : 'by email'}`,
    },
    pr: {
        label: 'Open translation PR', icon: AUI.pr, needs: 'github',
        def: { branch: 'l10n/updates', reviewers: 'auto' },
        fields: [
            { key: 'branch', type: 'text', label: 'Branch name' },
            { key: 'reviewers', type: 'select', label: 'Reviewers', options: [
                { value: 'auto', label: 'Auto · CODEOWNERS' }, { value: 'none', label: 'No reviewers' }, { value: 'pm', label: 'Localization PM' }] },
        ],
        summary: (c) => `to ${c.branch}`,
    },
    glossary: {
        label: 'Run glossary QA', icon: AUI.glossary, needs: null,
        def: { severity: 'block', scope: 'changed' },
        fields: [
            { key: 'severity', type: 'select', label: 'On violation', options: [
                { value: 'block', label: 'Block approval' }, { value: 'warn', label: 'Warn only' }, { value: 'autofix', label: 'Auto-fix where safe' }] },
            { key: 'scope', type: 'select', label: 'Check', options: [
                { value: 'changed', label: 'Changed segments' }, { value: 'all', label: 'All segments' }] },
        ],
        summary: (c) => (c.severity === 'block' ? 'block on violations' : c.severity === 'warn' ? 'warn only' : 'auto-fix where safe'),
    },
    status: {
        label: 'Move status', icon: AUI.status, needs: null,
        def: { to: 'in-review' },
        fields: [
            { key: 'to', type: 'select', label: 'Move to', options: [
                { value: 'in-translation', label: 'In translation' }, { value: 'in-review', label: 'In review' },
                { value: 'approved', label: 'Approved' }, { value: 'done', label: 'Done' }] },
        ],
        summary: (c) => `to ${pick(ACTIONS.status.fields[0].options, c.to)}`,
    },
    drive_save: {
        label: 'Save to cloud storage', icon: AUI.export, storageDest: true,
        def: { dest: 'gdrive', folder: '/Translations' },
        fields: [
            { key: 'dest', type: 'select', label: 'Destination', options: [
                { value: 'gdrive', label: 'Google Drive' }, { value: 'dropbox', label: 'Dropbox' }, { value: 'onedrive', label: 'OneDrive' }] },
            { key: 'folder', type: 'text', label: 'Folder path' },
        ],
        summary: (c) => `to ${CONNECTOR_META[c.dest]} ${c.folder}`,
    },
    figma_push: {
        label: 'Push strings to Figma', icon: AUI.figma, needs: 'figma',
        def: { mode: 'overwrite' },
        fields: [
            { key: 'mode', type: 'select', label: 'Apply as', options: [
                { value: 'overwrite', label: 'Overwrite text layers' }, { value: 'variant', label: 'Language variants' }] },
        ],
        summary: (c) => (c.mode === 'overwrite' ? 'overwriting text layers' : 'as language variants'),
    },
    figma_comment: {
        label: 'Comment on frame', icon: AUI.comment, needs: 'figma',
        def: { text: 'Translations ready for review' },
        fields: [{ key: 'text', type: 'text', label: 'Comment' }],
        summary: () => 'on the frame',
    },
    slack_dm: {
        label: 'Direct message', icon: AUI.message, needs: 'slack',
        def: { who: 'owner' },
        fields: [
            { key: 'who', type: 'select', label: 'Message', options: [
                { value: 'owner', label: 'Project owner' }, { value: 'assignee', label: 'Assigned linguist' }, { value: 'pm', label: 'Localization PM' }] },
        ],
        summary: (c) => `the ${c.who === 'owner' ? 'project owner' : c.who === 'assignee' ? 'assignee' : 'PM'}`,
    },
    commit: {
        label: 'Commit to branch', icon: AUI.push, needs: 'github',
        def: { branch: 'main', message: 'chore: update translations' },
        fields: [
            { key: 'branch', type: 'text', label: 'Branch' },
            { key: 'message', type: 'text', label: 'Commit message' },
        ],
        summary: (c) => `to ${c.branch}`,
    },
    gh_comment: {
        label: 'Comment on PR', icon: AUI.comment, needs: 'github',
        def: { body: 'Translations updated ✅' },
        fields: [{ key: 'body', type: 'text', label: 'Comment body' }],
        summary: () => 'on the pull request',
    },
};
const ACTION_GROUPS = [
    { id: 'core', label: 'Translation', connectors: [], items: ['translate', 'route', 'glossary', 'status', 'export'] },
    { id: 'storage', label: 'Cloud storage', connectors: ['gdrive', 'dropbox', 'onedrive'], items: ['drive_save'] },
    { id: 'figma', label: 'Figma', connectors: ['figma'], items: ['figma_push', 'figma_comment'] },
    { id: 'slack', label: 'Slack', connectors: ['slack'], items: ['notify', 'slack_dm'] },
    { id: 'github', label: 'GitHub', connectors: ['github'], items: ['pr', 'commit', 'gh_comment'] },
];

const actCfg = (ac) => ({ ...ACTIONS[ac.type].def, ...(ac.config || {}) });
const actSummary = (ac) => ACTIONS[ac.type].summary(actCfg(ac));

const COND_FIELDS = {
    language: { label: 'Target language', values: ['German', 'French', 'Japanese', 'Spanish', 'Italian', 'Portuguese', 'Chinese', 'Korean', 'Dutch', 'any target'] },
    source_lang: { label: 'Source language', values: ['English', 'German', 'French', 'Spanish', 'Japanese', 'any'] },
    folder: { label: 'Folder', values: ['Marketing', 'Brand', 'Product', 'Legal', 'Support', 'any'] },
    filetype: { label: 'File type', values: ['DOCX', 'JSON', 'XLIFF', 'Markdown', 'CSV', 'HTML', 'any'] },
    project: { label: 'Project', values: ['Spring Campaign', 'Help Center', 'Mobile App', 'Brand site', 'any'] },
    client: { label: 'Client', values: ['Acme Corp', 'Globex', 'Initech', 'Internal', 'any'] },
    assignee: { label: 'Assignee', values: ['Anja Müller', 'Luís Ferreira', 'Localization PM', 'unassigned', 'any'] },
    urgency: { label: 'Urgency', values: ['High', 'Medium', 'Low'] },
    wordcount: { label: 'Word count above', values: ['100', '500', '1,000', '5,000', '10,000'] },
    match: { label: 'TM match below', values: ['75%', '85%', '95%', '100%'] },
    quality: { label: 'Quality score below', values: ['70', '80', '90', '95'] },
    workflow: { label: 'Workflow stage', values: ['In translation', 'In review', 'Approved', 'Done'] },
    has_glossary: { label: 'Contains glossary term', values: ['yes', 'no'] },
};

// Conditions catalogue varies by trigger. If a trigger doesn't declare a
// `conds` list, fall back to the project-level set so the picker is never
// empty and rules built on legacy triggers still load.
const DEFAULT_CONDS = ['language', 'project', 'client'];
const condsFor = (triggerType) => {
    const def = TRIGGERS[triggerType];
    if (!def || !Array.isArray(def.conds) || def.conds.length === 0) return DEFAULT_CONDS;
    return def.conds.filter((k) => COND_FIELDS[k]);
};

const STATUS = {
    success: { label: 'Success', cls: 'ok' },
    failed: { label: 'Failed', cls: 'fail' },
    skipped: { label: 'Skipped', cls: 'skip' },
};

const TEMPLATES = [
    { name: 'Auto-route new projects', desc: 'When a project is created, route it to the right linguist by language pair.', trigger: 'project_created', actions: ['route', 'notify'] },
    { name: 'Catch glossary slips', desc: 'When a term is violated, block approval and DM the assignee.', trigger: 'glossary_violation', actions: ['glossary', 'slack_dm'] },
    { name: 'Re-check on source drift', desc: 'When source text changes after translation, re-translate the affected segments.', trigger: 'source_changed', actions: ['translate', 'notify'] },
    { name: 'Escalate rejected reviews', desc: 'When a segment is rejected, move it back to translation and notify the PM.', trigger: 'review_rejected', actions: ['status', 'notify'] },
    { name: 'Low-quality watchdog', desc: 'When AI quality dips below 80, assign for human review.', trigger: 'quality_low', actions: ['route', 'status'] },
    { name: 'Deadline reminder', desc: 'Ping owners 24h before a project is due.', trigger: 'deadline', actions: ['notify'] },
    { name: 'Deliver when 100% done', desc: 'Export and notify the moment every language is complete.', trigger: 'done', actions: ['export', 'notify'] },
    { name: 'Nightly pre-translate', desc: 'Pull new files overnight and pre-translate from TM.', trigger: 'schedule', actions: ['translate'] },
    { name: 'Translate on every PR', desc: 'Diff i18n files on each PR and open a translation PR back.', trigger: 'pr', actions: ['translate', 'pr'] },
];

const cloneState = (x) => JSON.parse(JSON.stringify(x));

// ============================================================
// Field primitives (local — mirror the patterns used elsewhere in RushPages)
// ============================================================
const SetBlock = ({ title, tag, desc, flush, children }) => (
    <div className="set-block">
        <div className={`set-block-head ${flush ? 'flush' : ''}`}>
            <h3>
                {title}
                {tag && <span style={{ marginLeft: 8, fontSize: 10.5, fontWeight: 700, letterSpacing: '.04em', textTransform: 'uppercase', color: 'var(--ink-4)' }}>{tag}</span>}
            </h3>
            {desc && <p>{desc}</p>}
        </div>
        {children}
    </div>
);
const SetField = ({ label, desc, stack, children }) => (
    <div className="set-field" style={stack ? { flexDirection: 'column', alignItems: 'stretch', gap: 8 } : null}>
        <div className="set-field-label">
            <div className="lbl">{label}</div>
            {desc && <div className="desc">{desc}</div>}
        </div>
        <div className="set-field-control" style={stack ? { width: '100%' } : null}>{children}</div>
    </div>
);
const SetText = ({ value, onChange, placeholder, wide }) => (
    <input className="set-input" type="text" value={value || ''} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} style={wide ? { width: '100%' } : null} />
);
const SetSelect = ({ value, onChange, options, minWidth }) => (
    <select className="set-input" value={value || ''} onChange={(e) => onChange(e.target.value)} style={minWidth ? { minWidth } : null}>
        {options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
    </select>
);
const SetToggle = ({ checked, onChange }) => (
    <button
        type="button"
        onClick={() => onChange(!checked)}
        aria-pressed={checked}
        style={{ width: 38, height: 22, borderRadius: 999, border: 0, background: checked ? 'var(--accent)' : 'var(--bg-soft)', position: 'relative', cursor: 'pointer' }}
    >
        <span style={{ position: 'absolute', top: 2, left: checked ? 18 : 2, width: 18, height: 18, background: 'white', borderRadius: 999, transition: 'left 0.15s', boxShadow: '0 1px 2px rgba(0,0,0,0.2)' }} />
    </button>
);
// Popover — renders absolutely-positioned menus through a portal anchored to a
// button so they escape ancestor overflow:auto / overflow:hidden clipping
// (the drawer body scrolls; FlowCard clips its corners). Coordinates are
// computed from the anchor's bounding rect and recomputed on scroll/resize.
const Popover = ({ anchorRef, onClose, placement = 'bottom-start', className, minWidth, matchAnchorWidth = true, children }) => {
    const [pos, setPos] = useState(null);
    const popRef = useRef(null);
    useLayoutEffect(() => {
        const calc = () => {
            const el = anchorRef.current;
            if (!el) return;
            const r = el.getBoundingClientRect();
            const width = matchAnchorWidth ? Math.max(r.width, minWidth || 0) : (minWidth || undefined);
            let top = r.bottom + 6;
            let left = r.left;
            if (placement === 'bottom-end') left = r.right - (width || r.width);
            if (placement === 'top-start') top = r.top - 6 - (popRef.current ? popRef.current.offsetHeight : 240);
            setPos({ top, left, width });
        };
        calc();
        window.addEventListener('resize', calc);
        window.addEventListener('scroll', calc, true);
        return () => {
            window.removeEventListener('resize', calc);
            window.removeEventListener('scroll', calc, true);
        };
    }, [anchorRef, placement, minWidth, matchAnchorWidth]);

    useEffect(() => {
        const h = (e) => {
            if (popRef.current && popRef.current.contains(e.target)) return;
            if (anchorRef.current && anchorRef.current.contains(e.target)) return;
            onClose();
        };
        document.addEventListener('mousedown', h);
        return () => document.removeEventListener('mousedown', h);
    }, [onClose, anchorRef]);

    if (!pos) return null;
    return ReactDOM.createPortal(
        <div
            ref={popRef}
            className={className}
            style={{
                position: 'fixed',
                top: pos.top,
                left: pos.left,
                width: pos.width,
                right: 'auto',
                bottom: 'auto',
                zIndex: 2000,
            }}
        >
            {children}
        </div>,
        document.body,
    );
};

const SetLangChips = ({ langs, all, onAdd, onRemove }) => {
    const [open, setOpen] = useState(false);
    const addRef = useRef(null);
    const remaining = all.filter((l) => !langs.some((s) => s.code === l.code));
    return (
        <div className="au-lang-chips">
            {langs.map((l) => (
                <span className="au-lang-chip" key={l.code}>
                    {l.code}
                    <button type="button" onClick={() => onRemove(l.code)} aria-label={`Remove ${l.name}`}>{AUI.x}</button>
                </span>
            ))}
            {remaining.length > 0 && (
                <button type="button" ref={addRef} className="au-lang-add" onClick={() => setOpen((o) => !o)}>
                    {AUI.plus} Add language
                </button>
            )}
            {open && (
                <Popover anchorRef={addRef} onClose={() => setOpen(false)} className="au-lang-menu" minWidth={220} matchAnchorWidth={false}>
                    {remaining.map((l) => (
                        <button key={l.code} type="button" className="au-lang-opt" onClick={() => { onAdd(l); setOpen(false); }}>
                            <span className="code">{l.code}</span>
                            <span>{l.name}</span>
                        </button>
                    ))}
                </Popover>
            )}
        </div>
    );
};

// ============================================================
// Connector-aware helpers
// ============================================================
const triggerNeeds = (tr) => {
    const def = TRIGGERS[tr.type];
    if (!def) return null;
    if (def.storage) return SOURCE_CONNECTOR[tr.source] || null;
    return def.needs || null;
};
const actionNeeds = (ac) => {
    const def = ACTIONS[ac.type];
    if (!def) return null;
    if (def.storageDest) return actCfg(ac).dest || null;
    return def.needs || null;
};
const missingConnectorsFor = (a, connected) => {
    const set = new Set();
    const tn = triggerNeeds(a.trigger); if (tn && !connected[tn]) set.add(tn);
    a.actions.forEach((ac) => { const an = actionNeeds(ac); if (an && !connected[an]) set.add(an); });
    return [...set];
};

// ============================================================
// Small UI helpers
// ============================================================
const Menu = ({ anchorRef, items, onClose }) => (
    <Popover anchorRef={anchorRef} onClose={onClose} placement="bottom-end" className="au-menu" minWidth={188} matchAnchorWidth={false}>
        {items.map((it, i) => (
            it.sep
                ? <div className="au-menu-sep" key={i} />
                : (
                    <button type="button" key={i} className={`au-menu-item ${it.danger ? 'danger' : ''}`} onClick={() => { it.onClick(); onClose(); }}>
                        <span className="ic">{it.icon}</span>{it.label}
                    </button>
                )
        ))}
    </Popover>
);

const FlowNode = ({ kind, label, sub, warn }) => (
    <div className={`au-node ${kind} ${warn ? 'warn' : ''}`}>
        <span className="au-node-ic">{label.icon}</span>
        <div className="au-node-b">
            <span className="k">{kind === 'trigger' ? 'When' : 'Then'}</span>
            <b>{label.label}</b>
            {sub && <small>{sub}</small>}
        </div>
    </div>
);

const FlowCard = ({ a, connected, onToggle, onEdit, onRuns, onDuplicate, onDelete }) => {
    const trig = TRIGGERS[a.trigger.type] || { label: a.trigger.type, icon: AUI.bolt };
    const [menu, setMenu] = useState(false);
    const moreRef = useRef(null);
    const missing = missingConnectorsFor(a, connected);
    const tNeed = triggerNeeds(a.trigger);
    return (
        <div className={`au-card ${a.enabled ? '' : 'off'}`}>
            <div className="au-card-h">
                <span className="au-card-name">{a.name}</span>
                <span className={`au-pill ${a.enabled ? 'on' : 'off'}`}>{a.enabled ? 'Active' : 'Paused'}</span>
                {missing.length > 0 && (
                    <a className="au-warn-chip" href="#/dashboard/sources" title={`${missing.map((m) => CONNECTOR_META[m]).join(', ')} not connected`}>
                        {AUI.warn}{missing.map((m) => CONNECTOR_META[m]).join(', ')} not connected
                    </a>
                )}
                <div className="grow" />
                <SetToggle checked={a.enabled} onChange={() => onToggle(a)} />
                <div style={{ position: 'relative' }}>
                    <button type="button" ref={moreRef} className="au-more" aria-label="More" onClick={() => setMenu((m) => !m)}>{AUI.more}</button>
                    {menu && (
                        <Menu anchorRef={moreRef} onClose={() => setMenu(false)} items={[
                            { label: 'View runs', icon: AUI.history, onClick: () => onRuns(a) },
                            { label: 'Edit', icon: AUI.pencil, onClick: () => onEdit(a) },
                            { label: 'Duplicate', icon: AUI.copy, onClick: () => onDuplicate(a) },
                            { sep: true },
                            { label: 'Delete', icon: AUI.trash, danger: true, onClick: () => onDelete(a) },
                        ]}
                        />
                    )}
                </div>
            </div>
            <div className="au-flow">
                <FlowNode kind="trigger" label={trig} sub={a.trigger.source} warn={tNeed && !connected[tNeed]} />
                {a.conditions.length > 0 && (
                    <>
                        <span className="au-arrow">{AUI.arrow}</span>
                        <span className="au-cond">If&nbsp;{a.conditions.map((c) => `${(COND_FIELDS[c.field] && COND_FIELDS[c.field].label.toLowerCase()) || c.field} ${c.value}`).join(' · ')}</span>
                    </>
                )}
                {a.actions.map((ac, i) => {
                    const an = actionNeeds(ac);
                    const adef = ACTIONS[ac.type] || { label: ac.type, icon: AUI.bolt };
                    return (
                        <React.Fragment key={i}>
                            <span className="au-arrow">{AUI.arrow}</span>
                            <FlowNode kind="action" label={adef} sub={ACTIONS[ac.type] ? actSummary(ac) : null} warn={an && !connected[an]} />
                        </React.Fragment>
                    );
                })}
            </div>
            <div className="au-card-f">
                <button type="button" className="au-runs-link" onClick={() => onRuns(a)}>
                    {AUI.history} Ran <b>{a.runs}</b> times · last {a.last}
                </button>
                <div className="grow" />
                <button type="button" className="set-btn sm" onClick={() => onEdit(a)}>Edit</button>
            </div>
        </div>
    );
};

const ConnectorWarn = ({ conn }) => (
    <div className="au-warn-banner">
        <span className="ic">{AUI.warn}</span>
        <div className="b">
            <b>{CONNECTOR_META[conn]} isn't connected.</b>
            <span>This step won't run until you link {CONNECTOR_META[conn]} on the Integrations page.</span>
        </div>
        <a className="set-btn sm" href="#/dashboard/sources">Connect</a>
    </div>
);

const GroupState = ({ connectors, connected }) => {
    if (!connectors || connectors.length === 0) return <span className="au-grp-state builtin">Built-in</span>;
    const on = connectors.filter((c) => connected[c]).length;
    const all = on === connectors.length;
    const some = on > 0;
    return (
        <span className={`au-grp-state ${all ? 'on' : some ? 'some' : 'off'}`}>
            <span className="dot" />
            {connectors.length === 1 ? (all ? 'Connected' : 'Not connected') : `${on}/${connectors.length} connected`}
        </span>
    );
};

const TriggerPicker = ({ value, onChange, connected }) => {
    const [open, setOpen] = useState(false);
    const btnRef = useRef(null);
    const cur = TRIGGERS[value];
    return (
        <div className="au-picker">
            <button type="button" ref={btnRef} className="au-picker-btn" onClick={() => setOpen((o) => !o)}>
                <span className="ic">{cur.icon}</span>
                <span className="lbl">{cur.label}</span>
                <span className="chev">{AUI.chev}</span>
            </button>
            {open && (
                <Popover anchorRef={btnRef} onClose={() => setOpen(false)} className="au-picker-menu">
                    {TRIGGER_GROUPS.map((g) => (
                        <div className="au-picker-group" key={g.id}>
                            <div className="au-picker-ghead">{g.label}<GroupState connectors={g.connectors} connected={connected} /></div>
                            {g.items.map((k) => {
                                const def = TRIGGERS[k];
                                const need = def.storage ? null : def.needs;
                                const off = need && !connected[need];
                                return (
                                    <button type="button" key={k} className={`au-picker-opt ${value === k ? 'sel' : ''}`} onClick={() => { onChange(k); setOpen(false); }}>
                                        <span className="ic">{def.icon}</span>
                                        <span className="lbl">{def.label}</span>
                                        {off && <span className="au-opt-need">needs {CONNECTOR_META[need]}</span>}
                                        {def.storage && <span className="au-opt-need muted">per source</span>}
                                    </button>
                                );
                            })}
                        </div>
                    ))}
                </Popover>
            )}
        </div>
    );
};

const ActionMenu = ({ anchorRef, onPick, onClose, connected }) => (
    <Popover anchorRef={anchorRef} onClose={onClose} className="au-act-menu grouped" minWidth={270} matchAnchorWidth={false}>
        {ACTION_GROUPS.map((g) => (
            <div className="au-picker-group" key={g.id}>
                <div className="au-picker-ghead">{g.label}<GroupState connectors={g.connectors} connected={connected} /></div>
                {g.items.map((k) => {
                    const def = ACTIONS[k];
                    const need = def.storageDest ? def.def.dest : def.needs;
                    const off = need && !connected[need];
                    return (
                        <div key={k} className="au-act-opt" onClick={() => onPick(k)}>
                            <span className="ic">{def.icon}</span>{def.label}
                            {off && <span className="au-opt-need">needs {CONNECTOR_META[need]}</span>}
                        </div>
                    );
                })}
            </div>
        ))}
    </Popover>
);

const ActionConfig = ({ ac, onChange, connected }) => {
    const def = ACTIONS[ac.type];
    const cfg = actCfg(ac);
    const need = actionNeeds(ac);
    const set = (k, v) => onChange({ ...ac, config: { ...cfg, [k]: v } });
    return (
        <div className="au-act-cfg">
            {need && !connected[need] && <ConnectorWarn conn={need} />}
            {def.fields.map((f) => (
                <SetField key={f.key} label={f.label} desc={f.desc} stack={f.type === 'langs'}>
                    {f.type === 'select' && (
                        <SetSelect value={cfg[f.key]} onChange={(v) => set(f.key, v)} minWidth={200} options={f.options} />
                    )}
                    {f.type === 'toggle' && (
                        <SetToggle checked={!!cfg[f.key]} onChange={(v) => set(f.key, v)} />
                    )}
                    {f.type === 'text' && (
                        <SetText value={cfg[f.key]} onChange={(v) => set(f.key, v)} placeholder="branch-name" />
                    )}
                    {f.type === 'langs' && (
                        <SetLangChips
                            langs={(cfg[f.key] || []).map((code) => ({ code, name: langName(code) }))}
                            all={TARGET_LANGS}
                            onAdd={(l) => set(f.key, [...(cfg[f.key] || []), l.code])}
                            onRemove={(code) => set(f.key, (cfg[f.key] || []).filter((c) => c !== code))}
                        />
                    )}
                </SetField>
            ))}
        </div>
    );
};

const blankAuto = () => ({
    id: 'new', name: '', enabled: true,
    trigger: { type: 'project_created', source: '' },
    conditions: [], actions: [{ type: 'translate' }],
});

const Builder = ({ initial, isNew, connected, onClose, onSave }) => {
    const [a, setA] = useState(() => cloneState(initial));
    const [addOpen, setAddOpen] = useState(false);
    const [expanded, setExpanded] = useState(isNew ? 0 : -1);
    const addBtnRef = useRef(null);
    const trig = TRIGGERS[a.trigger.type];
    const tNeed = triggerNeeds(a.trigger);

    const setTriggerType = (type) => {
        const tr = TRIGGERS[type];
        const allowed = condsFor(type);
        // Drop conditions that don't apply to the new trigger — e.g. switching
        // from "File added" to "Segment approved" should strip a "Folder is
        // Marketing" rule that no longer has any meaning.
        setA((x) => ({
            ...x,
            trigger: { type, source: tr.srcs ? tr.srcs[0] : '' },
            conditions: x.conditions.filter((c) => allowed.includes(c.field)),
        }));
    };
    const condOpts = condsFor(a.trigger.type);
    const addCond = () => {
        const first = condOpts[0];
        setA((x) => ({ ...x, conditions: [...x.conditions, { field: first, value: COND_FIELDS[first].values[0] }] }));
    };
    const setCond = (i, k, v) => setA((x) => ({ ...x, conditions: x.conditions.map((c, j) => (j === i ? { ...c, [k]: v, ...(k === 'field' ? { value: COND_FIELDS[v].values[0] } : {}) } : c)) }));
    const rmCond = (i) => setA((x) => ({ ...x, conditions: x.conditions.filter((_, j) => j !== i) }));
    const addAction = (type) => { setA((x) => ({ ...x, actions: [...x.actions, { type }] })); setExpanded(a.actions.length); setAddOpen(false); };
    const setAction = (i, next) => setA((x) => ({ ...x, actions: x.actions.map((ac, j) => (j === i ? next : ac)) }));
    const rmAction = (i) => { setA((x) => ({ ...x, actions: x.actions.filter((_, j) => j !== i) })); setExpanded(-1); };

    const canSave = a.name.trim() && a.actions.length > 0;

    return (
        <div className="src-drawer-wrap" onMouseDown={(e) => { if (e.target.classList.contains('src-drawer-wrap')) onClose(); }}>
            <div className="src-drawer au-drawer">
                <div className="src-drawer-h">
                    <span className="au-drawer-ic">{AUI.bolt}</span>
                    <div className="meta"><b>{isNew ? 'New automation' : 'Edit automation'}</b><span>Run actions automatically when something happens.</span></div>
                    <button type="button" className="src-drawer-x" onClick={onClose} aria-label="Close">{AUI.x}</button>
                </div>

                <div className="src-drawer-body">
                    <SetBlock title="Name">
                        <div style={{ padding: '14px 0' }}>
                            <SetText wide value={a.name} onChange={(v) => setA((x) => ({ ...x, name: v }))} placeholder="e.g. Localize on every PR" />
                        </div>
                    </SetBlock>

                    <SetBlock title="When" tag="Trigger" desc="The event that starts this automation.">
                        <SetField label="Trigger" stack>
                            <TriggerPicker value={a.trigger.type} onChange={setTriggerType} connected={connected} />
                        </SetField>
                        {trig.srcs && (
                            <SetField label={trig.srcLabel}>
                                <SetSelect
                                    value={a.trigger.source}
                                    onChange={(v) => setA((x) => ({ ...x, trigger: { ...x.trigger, source: v } }))}
                                    minWidth={180}
                                    options={trig.srcs.map((s) => ({ value: s, label: s }))}
                                />
                            </SetField>
                        )}
                        {tNeed && !connected[tNeed] && <div style={{ padding: '0 22px 16px' }}><ConnectorWarn conn={tNeed} /></div>}
                    </SetBlock>

                    <SetBlock title="If" tag="Conditions" flush desc="Optional — only run when these match.">
                        {a.conditions.map((c, i) => (
                            <div className="au-cond-row" key={i}>
                                <SetSelect value={c.field} onChange={(v) => setCond(i, 'field', v)} minWidth={150}
                                    options={condOpts.map((k) => ({ value: k, label: COND_FIELDS[k].label }))} />
                                <span className="au-is">is</span>
                                <SetSelect value={c.value} onChange={(v) => setCond(i, 'value', v)} minWidth={130}
                                    options={COND_FIELDS[c.field].values.map((v) => ({ value: v, label: v }))} />
                                <button type="button" className="au-rm" onClick={() => rmCond(i)} aria-label="Remove">{AUI.x}</button>
                            </div>
                        ))}
                        <div className="au-add-row"><button type="button" className="set-btn sm" onClick={addCond}>{AUI.plus} Add condition</button></div>
                    </SetBlock>

                    <SetBlock title="Then" tag="Actions" flush desc="What happens, in order. Click a step to configure it.">
                        {a.actions.map((ac, i) => {
                            const an = actionNeeds(ac);
                            const isOpen = expanded === i;
                            return (
                                <div className={`au-act ${isOpen ? 'open' : ''}`} key={i}>
                                    <div className="au-act-row" onClick={() => setExpanded(isOpen ? -1 : i)}>
                                        <span className="au-act-ic">{ACTIONS[ac.type].icon}</span>
                                        <div className="au-act-b">
                                            <b>{ACTIONS[ac.type].label}</b>
                                            <span>{actSummary(ac)}</span>
                                        </div>
                                        {an && !connected[an] && <span className="au-need">{AUI.warn}{CONNECTOR_META[an]}</span>}
                                        <span className={`au-act-chev ${isOpen ? 'open' : ''}`}>{AUI.chev}</span>
                                        <button type="button" className="au-rm" onClick={(e) => { e.stopPropagation(); rmAction(i); }} aria-label="Remove">{AUI.x}</button>
                                    </div>
                                    {isOpen && <ActionConfig ac={ac} onChange={(next) => setAction(i, next)} connected={connected} />}
                                </div>
                            );
                        })}
                        <div className="au-add-row" style={{ position: 'relative' }}>
                            <button type="button" ref={addBtnRef} className="set-btn sm" onClick={() => setAddOpen((o) => !o)}>{AUI.plus} Add action</button>
                            {addOpen && <ActionMenu anchorRef={addBtnRef} onPick={addAction} onClose={() => setAddOpen(false)} connected={connected} />}
                        </div>
                    </SetBlock>

                    <SetBlock title="Status">
                        <SetField label="Enable this automation" desc="Turn it on as soon as you save.">
                            <SetToggle checked={a.enabled} onChange={(v) => setA((x) => ({ ...x, enabled: v }))} />
                        </SetField>
                    </SetBlock>
                </div>

                <div className="src-drawer-foot">
                    <div className="grow" />
                    <button type="button" className="set-btn" onClick={onClose}>Cancel</button>
                    <button
                        type="button"
                        className="set-btn accent"
                        onClick={() => onSave(a)}
                        disabled={!canSave}
                        style={!canSave ? { opacity: 0.5, cursor: 'not-allowed' } : null}
                    >
                        {isNew ? 'Create automation' : 'Save changes'}
                    </button>
                </div>
            </div>
        </div>
    );
};

const RunHistory = ({ a, onClose, onRerun }) => {
    const total = a.history.length;
    const ok = a.history.filter((r) => r.status === 'success').length;
    const rate = total ? Math.round((ok / total) * 100) : 100;
    return (
        <div className="src-drawer-wrap" onMouseDown={(e) => { if (e.target.classList.contains('src-drawer-wrap')) onClose(); }}>
            <div className="src-drawer au-runs-drawer">
                <div className="src-drawer-h">
                    <span className="au-drawer-ic">{AUI.history}</span>
                    <div className="meta"><b>{a.name}</b><span>Run history</span></div>
                    <button type="button" className="src-drawer-x" onClick={onClose} aria-label="Close">{AUI.x}</button>
                </div>
                <div className="src-drawer-body">
                    <div className="au-runs-stats">
                        <div className="au-runs-stat"><div className="v">{(a.runs || 0).toLocaleString()}</div><div className="l">Total runs</div></div>
                        <div className="au-runs-stat"><div className="v">{rate}%</div><div className="l">Success (recent)</div></div>
                        <div className="au-runs-stat"><div className="v">{a.last}</div><div className="l">Last run</div></div>
                    </div>
                    <div className="au-runs-list">
                        {a.history.length === 0 && <div className="au-runs-empty">No runs yet. This automation will appear here the first time it fires.</div>}
                        {a.history.map((r) => (
                            <div className={`au-run ${STATUS[r.status].cls}`} key={r.id}>
                                <span className="au-run-dot" />
                                <div className="au-run-main">
                                    <div className="au-run-top">
                                        <b>{r.title}</b>
                                        <span className={`au-run-badge ${STATUS[r.status].cls}`}>{STATUS[r.status].label}</span>
                                        <time>{r.when}{r.dur ? ` · ${r.dur}` : ''}</time>
                                    </div>
                                    <div className="au-run-detail">{r.detail}</div>
                                    {r.error && (
                                        <div className="au-run-err">
                                            <span className="ic">{AUI.warn}</span>
                                            <span className="msg">{r.error}</span>
                                            <button type="button" className="set-btn sm" onClick={() => onRerun(a, r)}>{AUI.rerun} Re-run</button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="src-drawer-foot">
                    <div className="grow" />
                    <button type="button" className="set-btn" onClick={onClose}>Close</button>
                </div>
            </div>
        </div>
    );
};

// ============================================================
// Server-shape adapters
// ============================================================
// The existing /api/automations stores a flatter shape. Normalize on read so
// the rich builder UI doesn't have to special-case missing fields.
const normalize = (raw) => ({
    id: raw._id || raw.id,
    _id: raw._id,
    name: raw.name || 'Untitled automation',
    enabled: raw.enabled !== false,
    trigger: raw.trigger && typeof raw.trigger === 'object'
        ? { type: raw.trigger.type || 'pr', source: raw.trigger.source || '' }
        : { type: raw.triggerType || 'pr', source: raw.triggerSource || '' },
    conditions: Array.isArray(raw.conditions) ? raw.conditions : [],
    actions: Array.isArray(raw.actions) ? raw.actions.map((ac) => (typeof ac === 'string' ? { type: ac } : ac)) : [],
    runs: raw.runs || 0,
    last: raw.last || (raw.lastRun ? new Date(raw.lastRun).toLocaleString() : 'never'),
    history: Array.isArray(raw.history) ? raw.history : [],
});

const Automations = () => {
    const token = useSelector((s) => s.auth.token);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [autos, setAutos] = useState([]);
    const [connected, setConnected] = useState(DEFAULT_CONNECTED);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [builder, setBuilder] = useState(null); // { initial, isNew }
    const [runsForId, setRunsForId] = useState(null);

    useEffect(() => {
        if (!token) return;
        const headers = { Authorization: `Bearer ${token}` };
        axios.get('/api/automations', { headers })
            .then((r) => { setAutos((r.data || []).map(normalize)); setLoading(false); })
            .catch((err) => {
                if (err.response && err.response.status === 401) {
                    dispatch(logout()); navigate('/login');
                } else {
                    setError('Failed to load automations.'); setLoading(false);
                }
            });
        // /api/integrations/status reports each provider as a top-level
        // boolean. Map its key set to the connector ids the builder uses.
        axios.get('/api/integrations/status', { headers })
            .then((r) => {
                if (r.data && typeof r.data === 'object') {
                    setConnected({
                        gdrive: !!r.data.google,
                        dropbox: !!r.data.dropbox,
                        onedrive: !!r.data.onedrive,
                        slack: !!r.data.slack,
                        figma: !!r.data.figma,
                        github: !!r.data.github,
                    });
                }
            })
            .catch(() => { /* fall back to defaults */ });
    }, [token, dispatch, navigate]);

    const persist = async (a) => {
        const headers = { Authorization: `Bearer ${token}` };
        const payload = {
            name: a.name, enabled: a.enabled, trigger: a.trigger,
            conditions: a.conditions, actions: a.actions,
        };
        if (a.id === 'new' || !a._id) {
            const r = await axios.post('/api/automations', payload, { headers });
            return normalize(r.data);
        }
        const r = await axios.patch(`/api/automations/${a._id}`, payload, { headers });
        return normalize({ ...a, ...r.data });
    };

    const onToggle = async (a) => {
        const next = { ...a, enabled: !a.enabled };
        setAutos((list) => list.map((x) => (x.id === a.id ? next : x)));
        try {
            await axios.patch(`/api/automations/${a._id}`, { enabled: next.enabled }, { headers: { Authorization: `Bearer ${token}` } });
        } catch (e) {
            setAutos((list) => list.map((x) => (x.id === a.id ? a : x))); // revert
        }
    };
    const onSave = async (a) => {
        try {
            const saved = await persist(a);
            setAutos((list) => {
                if (a.id === 'new') return [saved, ...list];
                return list.map((x) => (x.id === a.id ? saved : x));
            });
            setBuilder(null);
        } catch (e) {
            setError('Failed to save automation.');
        }
    };
    const onDuplicate = async (a) => {
        const copy = { ...cloneState(a), id: 'new', _id: undefined, name: `${a.name} (copy)`, enabled: false, runs: 0, last: 'never', history: [] };
        try {
            const saved = await persist(copy);
            setAutos((list) => {
                const idx = list.findIndex((x) => x.id === a.id);
                const next = [...list]; next.splice(idx + 1, 0, saved); return next;
            });
        } catch (e) { setError('Failed to duplicate automation.'); }
    };
    const onDelete = async (a) => {
        if (!window.confirm(`Delete “${a.name}”? This can’t be undone.`)) return;
        try {
            await axios.delete(`/api/automations/${a._id}`, { headers: { Authorization: `Bearer ${token}` } });
            setAutos((list) => list.filter((x) => x.id !== a.id));
        } catch (e) { setError('Failed to delete automation.'); }
    };
    const onRerun = async (a, r) => {
        // Optimistic: drop a "just now" entry in immediately so the drawer
        // updates without waiting on the round-trip; replace with the server
        // copy when it returns.
        const optimistic = { id: `r${Date.now()}`, when: 'just now', status: 'success', title: `Re-run · ${r.title}`, detail: 'Manual re-run completed successfully', dur: '1.0s' };
        setAutos((list) => list.map((x) => (x.id === a.id ? {
            ...x, runs: x.runs + 1, last: 'just now', history: [optimistic, ...x.history],
        } : x)));
        try {
            const resp = await axios.post(
                `/api/automations/${a._id}/rerun`,
                { title: r.title },
                { headers: { Authorization: `Bearer ${token}` } },
            );
            const saved = normalize(resp.data);
            setAutos((list) => list.map((x) => (x.id === a.id ? saved : x)));
        } catch (e) {
            // Leave the optimistic entry; surface a soft error rather than
            // ripping the row out from under the user.
            setError('Re-run failed to persist.');
        }
    };

    const fromTemplate = (tpl) => setBuilder({
        isNew: true,
        initial: {
            id: 'new', name: tpl.name, enabled: true,
            trigger: { type: tpl.trigger, source: TRIGGERS[tpl.trigger].srcs ? TRIGGERS[tpl.trigger].srcs[0] : '' },
            conditions: [],
            actions: tpl.actions.map((type) => ({ type })),
        },
    });

    if (loading) return <div style={{ padding: 40, color: 'var(--ink-3)' }}>Loading automations…</div>;

    const activeCount = autos.filter((a) => a.enabled).length;
    const totalRuns = autos.reduce((s, a) => s + (a.runs || 0), 0);
    const needsAttention = autos.filter((a) => a.enabled && missingConnectorsFor(a, connected).length > 0).length;
    const runsAuto = runsForId ? autos.find((a) => a.id === runsForId) : null;

    return (
        <>
            <div className="rs-page-title-row">
                <h1 className="rs-page-title">Automations</h1>
                <div className="rs-page-actions">
                    <button type="button" className="btn-p" onClick={() => setBuilder({ initial: blankAuto(), isNew: true })}>
                        {AUI.plus} New automation
                    </button>
                </div>
            </div>
            <p className="rs-page-sub">Put your localization on autopilot. When something happens in a connected source, Rush Studio runs the steps for you.</p>

            {error && <div style={{ marginBottom: 14, padding: 10, borderRadius: 10, background: 'color-mix(in oklab, #d0492f 10%, transparent)', color: '#c0432c', fontSize: 12.5 }}>{error}</div>}

            <div className="au-stats">
                <div className="au-stat"><div className="v">{activeCount}<span className="u">/ {autos.length}</span></div><div className="l">Active automations</div></div>
                <div className="au-stat"><div className="v">{totalRuns.toLocaleString()}</div><div className="l">Runs this month</div></div>
                <div className="au-stat"><div className="v">38<span className="u">hrs</span></div><div className="l">Saved this month</div></div>
                <div className={`au-stat ${needsAttention ? 'alert' : ''}`}>
                    <div className="v">{needsAttention}</div>
                    <div className="l">{needsAttention ? 'Need attention' : 'All healthy'}</div>
                </div>
            </div>

            <div className="au-list">
                {autos.map((a) => (
                    <FlowCard
                        key={a.id}
                        a={a}
                        connected={connected}
                        onToggle={onToggle}
                        onEdit={(au) => setBuilder({ initial: au, isNew: false })}
                        onRuns={(au) => setRunsForId(au.id)}
                        onDuplicate={onDuplicate}
                        onDelete={onDelete}
                    />
                ))}
            </div>

            <div className="au-templates-h">Start from a recipe</div>
            <div className="au-templates">
                {TEMPLATES.map((tpl) => (
                    <button type="button" className="au-tpl" key={tpl.name} onClick={() => fromTemplate(tpl)}>
                        <span className="au-tpl-ic">{TRIGGERS[tpl.trigger].icon}</span>
                        <div className="au-tpl-b"><b>{tpl.name}</b><span>{tpl.desc}</span></div>
                        <span className="au-tpl-go">{AUI.plus}</span>
                    </button>
                ))}
            </div>

            {builder && <Builder initial={builder.initial} isNew={builder.isNew} connected={connected} onClose={() => setBuilder(null)} onSave={onSave} />}
            {runsAuto && <RunHistory a={runsAuto} onClose={() => setRunsForId(null)} onRerun={onRerun} />}
        </>
    );
};

export default Automations;
